export default __webpack_public_path__ + "static/media/confi-2.258360be.jpg";